var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-finance"},[_c('el-row',{staticClass:"infoLink"},[_c('router-link',{attrs:{"to":"/my/finance/deposit"}},[_vm._v(_vm._s(_vm.$t("myPage.Deposit")))]),_c('router-link',{attrs:{"to":"/my/finance/withdraw"}},[_vm._v(_vm._s(_vm.$t("myPage.drawing")))])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }